<script setup lang="ts">
  import { computed } from 'vue';
  import { Tooltip } from '@/shared/ui';
  import type { DocumentDistributionGroupedData } from '../../model/distribution.types';

  interface Props {
    data: DocumentDistributionGroupedData;
  }

  const props = defineProps<Props>();

  const rows = computed(() => [
    [
      { type: 'Manual da Qualidade', items: props.data.qualityManual },
      { type: 'Procedimento', items: props.data.procedure },
      { type: 'Instrução de Trabalho', items: props.data.workInstruction },
      { type: 'Dados', items: props.data.supportDocument },
    ],
    [{ type: 'Documento Externo', items: props.data.externalDocument }],
  ]);
</script>

<template>
  <div
    v-for="(rowColumns, rowIndex) in rows"
    :key="rowIndex"
    class="grid grid-cols-4 mx-6 border-gray-02"
    :class="
      rowIndex === 0
        ? 'border-x border-t rounded-t-2xl'
        : 'border-x border-b border-t border-t-border-color rounded-b-2xl mb-6'
    "
  >
    <div
      v-for="(column, colIndex) in rowColumns"
      :key="column.type"
      class="flex flex-col px-3 py-6 gap-2 min-w-0"
      :class="{ 'border-r border-border-color': colIndex < 3 }"
    >
      <div class="pb-6">
        <span class="text-[var(--theme-secondary-ink)] font-semibold text-[15px]">
          {{ column.type }}
        </span>
      </div>
      <div class="flex flex-col gap-4">
        <div
          v-for="(item, itemIndex) in column.items"
          :key="itemIndex"
          class="flex flex-row gap-4"
        >
          <div class="flex flex-col text-gray-700 text-sm gap-2 flex-1 min-w-0">
            <span class="font-semibold">Prefixo</span>
            <div
              class="border border-border-color bg-gray-02/20 rounded-lg h-12 flex items-center px-3 py-2 overflow-hidden"
            >
              <span class="truncate text-sm">{{ item.document }}</span>
            </div>
          </div>
          <div class="flex flex-col text-gray-700 text-sm gap-2 flex-1 min-w-0">
            <span class="font-semibold">Local</span>
            <Tooltip :content="item.local">
              <div
                class="border border-border-color bg-gray-02/20 rounded-lg h-12 flex items-center px-3 py-2 overflow-hidden"
              >
                <span class="truncate text-sm">{{ item.local }}</span>
              </div>
            </Tooltip>
          </div>
          <div class="flex flex-col text-gray-700 text-sm gap-2 shrink-0">
            <span class="font-semibold">Qtde.</span>
            <div
              class="border border-border-color bg-gray-02/20 rounded-lg h-12 flex items-center px-3 py-2 w-14"
            >
              <span class="text-sm">{{ item.quantity }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
